import { useContext, useState } from 'react';
import { ClickToActionProps } from '../interface/interface';
import isMobile from 'ismobilejs';
import { UserContext } from '../context/userContext';
import { nativeService } from '../helpers/nativeService';

const ctaStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const ClickToAction = ({
  buttonText,
  className,
  buttonImg,
  href,
}: ClickToActionProps) => {
  const { nativeView } = useContext(UserContext);
  const [target] = useState<string>(
    isMobile(window.navigator).any || !nativeView ? '_self' : '_blank',
  );

  const handleClick = (e: React.MouseEvent) => {
    if (nativeView) {
      e.preventDefault();
      nativeService(JSON.stringify({ consultationUrl: href }));
    }
  };

  return (
    <a
      className={className}
      style={ctaStyle}
      href={href}
      target={target}
      rel="noreferrer"
      onClick={handleClick}
    >
      <span className="mr-3">{buttonImg}</span>
      <span>{buttonText}</span>
    </a>
  );
};

export default ClickToAction;
